import { Component } from "react";
import styles from "./styles/ToggleInput.module.scss";
import classNames from "classnames";
import { Switch, SwitchProps } from "@radix-ui/themes";

interface IToggleSwitchProps extends Omit<
  SwitchProps,
  "checked" | "onCheckedChange" | "disabled" | "onClick"
> {
  on: boolean;
  onClick?: (checked: boolean) => void;
  enabled?: boolean;
  wrapperClassName?: string;
}

export default class ToggleSwitch extends Component<IToggleSwitchProps> {
  static defaultProps = {
    enabled: true,
  };

  render() {
    const { on, onClick, enabled, wrapperClassName, ...restProps } = this.props;

    const switchClassName = classNames({
      [styles.switch]: true,
      [wrapperClassName ?? ""]: wrapperClassName,
    });

    return (
      <div className={switchClassName}>
        <Switch
          checked={on}
          onCheckedChange={onClick}
          disabled={!enabled}
          size={"3"}
          {...restProps}
        />
      </div>
    );
  }
}
